import { StorageAdapter } from './StorageAdapter';

/**
 * localStorage implementation of StorageAdapter.
 * Provides synchronous access to browser's localStorage.
 */
export class LocalStorageAdapter implements StorageAdapter {
    getItem(key: string): string | null {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            console.error('LocalStorageAdapter.getItem failed:', error);
            return null;
        }
    }

    setItem(key: string, value: string): void {
        try {
            window.localStorage.setItem(key, value);
        } catch (error) {
            console.error('LocalStorageAdapter.setItem failed:', error);
        }
    }

    removeItem(key: string): void {
        try {
            window.localStorage.removeItem(key);
        } catch (error) {
            console.error('LocalStorageAdapter.removeItem failed:', error);
        }
    }

    clear(): void {
        try {
            window.localStorage.clear();
        } catch (error) {
            console.error('LocalStorageAdapter.clear failed:', error);
        }
    }
}
